import {
  getToken,
  setToken,
  removeToken,
  getAgentUserId,
  setAgentUserId,
  removeAgentUserId,
  getAgentId,
  setAgentId,
  removeAgentId,
  getUsername,
  setUsername,
  removeUsername,
  getUserImportType,
  setUserImportType,
  removeUserImportType,
  setResources,
  getResources,
  removeResources
} from "@/utils/auth";

const user = {
  state: {
    token: getToken(),
    agentUserId: getAgentUserId(),
    agentId: getAgentId(),
    username: getUsername(),
    userImportType: getUserImportType(),
    avatar: "",
    resources: getResources()
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_AGENT_ID: (state, agentId) => {
      state.agentId = agentId;
    },
    SET_AGENT_USER_ID: (state, agentUserId) => {
      state.agentUserId = agentUserId;
    },
    SET_USER_NAME: (state, username) => {
      state.username = username;
    },
    SET_USER_IMPORT_TYPE: (state, userImportType) => {
      state.userImportType = userImportType;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_RESOURCES: (state, resources) => {
      state.resources = resources;
    }
  },

  actions: {
    //保存登录信息
    saveAccessInfo({ commit }, info) {
      var accessInfo = info[0];
      var resources = info[1];
      setToken(accessInfo["token"]);
      commit("SET_TOKEN", accessInfo["token"]);
      setAgentId(accessInfo["agentId"]);
      commit("SET_AGENT_ID", accessInfo["agentId"]);
      setAgentUserId(accessInfo["agentUserId"]);
      commit("SET_AGENT_USER_ID", accessInfo["agentUserId"]);
      setUsername(accessInfo["agentName"]);
      commit("SET_USER_NAME", accessInfo["agentName"]);
      setUserImportType(accessInfo["userImportType"]);
      commit("SET_USER_IMPORT_TYPE", accessInfo["userImportType"]);
      if (resources) {
        commit("SET_RESOURCES", resources);
        setResources(resources);
      }
    },
    clearAccessInfo({ commit }) {
      commit("SET_TOKEN", "");
      removeToken();
      commit("SET_AGENT_ID", "");
      removeAgentId();
      commit("SET_AGENT_USER_ID", "");
      removeAgentUserId();
      commit("SET_RESOURCES", {});
      removeResources();
      commit("SET_USER_NAME", "");
      removeUsername();
      commit("SET_USER_IMPORT_TYPE", "");
      removeUserImportType();
    }
  }
};

export default user;
